export const allproducts = [
  {
    brand: "Huawei",
    name: "Huawei OLT EA5800_X7",
    image: require("../assets/allproducts/EA5800.png"),
    link: "https://e.huawei.com/en/products/optical-access/ea5800",
    badges: [
      { label: "OLT", color: "purple" },
      { label: "Enterprise", color: "blue" },
      { label: "High Capacity", color: "green" }
    ]
  },

  {
    brand: "Huawei",
    name: "CloudEngine S5735-L48P4XE-A-V2",
    image: require("../assets/allproducts/CloudEngine S5735-L48P4S-A1.png"),
    link: "https://support.huawei.com/enterprise/en/doc/EDOC1100277349/a75e5938/s5735-l48p4xe-a-v2",
    badges: [
      { label: "Switch", color: "teal" },
      { label: "48P", color: "blue" },
      { label: "Enhanced", color: "green" }
    ]
  },
  {
    brand: "Huawei",
    name: "CloudEngine S5735-L24P4S-A-V2",
    image: require("../assets/allproducts/CloudEngine S5735-L24P4S-A-V2.png"),
    link: "https://support.huawei.com/enterprise/en/doc/EDOC1100277349/d19b0399/s5735-l24p4s-a-v2-98012021",
    badges: [
      { label: "Switch", color: "teal" },
      { label: "24P", color: "blue" },
      { label: "Enterprise", color: "purple" }
    ]
  },
  {
    brand: "Huawei",
    name: "CloudEngine S6730-H48X6C-V2",
    image: require("../assets/allproducts/CloudEngine S6730-H48X6C-V2.png"),
    link: "https://support.huawei.com/enterprise/en/doc/EDOC1100214356/8e31f10d/s6730-h48x6c-v2",
    badges: [
      { label: "CoreSwitch", color: "teal" },
      { label: "48X", color: "blue" },
      { label: "Data Center", color: "amber" }
    ]
  },
   {
    brand: "Huawei",
    name: "AC6508 Access Controller",
    image: require("../assets/allproducts/AC6508-WLAN-Access-Controller.png"),
    link: "https://e.huawei.com/en/products/wlan/access-controllers/ac6508",
    badges: [
      { label: "WLAN", color: "green" },
      { label: "Wireless", color: "teal" },
      { label: "Indoor/Outdoor", color: "purple" }
    ]
  },
   {
    brand: "Huawei",
    name: "MINI FTTO - F1001-AC OLT",
    image: require("../assets/allproducts/miniftto.png"),
    link: "https://e.huawei.com/en/solutions/enterprise-optical-network/miniftto",
    badges: [
      { label: "OLT", color: "purple" },
      { label: "FTTO", color: "green" },
      { label: "Enterprise", color: "blue" }
    ]
  }
 
  
];

export const productBrands = [...new Set(allproducts.map(p => p.brand))];